import React, { Component } from 'react';
import footerlogo from "./images/myyshopp-logo-orange.png";
import facebook from "./images/facebook.png";
import instagram from "./images/instagram.png";
import twitter from "./images/twitter.png";
import youtube from "./images/youtube.png";
import mastercard from "./images/mastercard.png";
import visa from "./images/visa.png";
import paypal from "./images/paypal.png";
import americanexpress from "./images/american-express.png";

export default class footer extends Component {
    render() {
        return (
        <div class="myyshopp-footer">
            <div class="myyshopp-footer-bgclr">
                <div class="container">
                   <div class="row">
                       <div class="col-md-4">
                            <div class="logofooterDiv">
                                <img src={footerlogo} class="img-fluid" alt=""></img>
                            </div>
                            <p>T: <span><a href="tel:+91 9820041253">+91 98 20 04 12 53</a></span></p>
                            <p>E: <span><a  href="mailto:support@myyshopp.com?Subject=Hello%20Sir" target="_top">support@myyshopp.com</a></span></p>
                            <div class="mshop-socialDiv">
                                <a href="https://www.facebook.com/gotomyyshopp"><img src={facebook} width="28" alt=""></img></a>
                                <a href="https://www.instagram.com/myyshopp.social/"><img src={instagram} width="28" alt=""></img></a>
                                <a href="https://twitter.com/Myy_Shopp"><img src={twitter} width="28" alt=""></img></a>
                                <a href="https://www.youtube.com/channel/UC634wdXJT4oY29Y3gzi6viQ"><img src={youtube} width="28" alt=""></img></a>
                            </div>
                       </div>
                       <div class="col-md-2 mshopp-footer-list">
                            <h4>ABOUT</h4>                   
                            <p><a href="/myyshopp/our-dna">Our DNA</a></p>
                            <p><a href="/myyshopp/team">The Team</a></p>
                        </div>
                        <div class="col-md-2 mshopp-footer-list">
                            <h4>BUSINESS     </h4>                   
                            <p><a href="/myyshopp/our-investor">Our Investor</a></p>
                            <p><a href="/myyshopp/career">Career</a></p>
                        </div>
                        <div class="col-md-2 mshopp-footer-list">
                            <h4>Support</h4>                   
                            <p><a href="/myyshopp/helpcentre">Help Center</a> </p>
                            <p><a href="/myyshopp/contact">Contact us</a> </p>
                        </div>
                        <div class="col-md-12 text-center">
                            <p class="py-4">©{new Date().getFullYear()} MyyShopp eCommerce Technologies Pvt. Ltd.</p>
                        </div>
                   </div>
                   <div class="row pb-3">
                       <div class="col-md-5 pt-4">
                            <a className="pr-4" href="../myyshopp/privacy">Privacy & policy</a>
                            <a href="../myyshopp/terms_Conditions">Terms of User</a>
                       </div>
                       <div class="col-md-7 mshopp-debit">
                           <img src={mastercard} class="img-fluid" alt=""></img>
                           <img src={visa} class="img-fluid" alt=""></img>
                           <img src={paypal} class="img-fluid" alt=""></img>
                           <img src={americanexpress} class="img-fluid" alt=""></img>
                       </div>
                    </div>
                </div>
            </div>
        </div>
        )
    }        
}